// @ts-nocheck
"use client"
import {
    useQuery,
    useMutation,
    useQueryClient,
    keepPreviousData,
    UseMutationOptions,
    UseQueryOptions
} from "@tanstack/react-query"


export const useApiGet = <T>(key, fn, options?: Omit<UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>) => useQuery<T>({
    queryKey: key,
    queryFn: fn,
    placeholderData: keepPreviousData,
    ...options
})


export const useApiSend = <TData = any, TError = Error, TVariables = void>(
    fn: (variables: TVariables) => Promise<TData>,
    success?: (data: TData) => void,
    error?: (err: {description: string}) => void,
    invalidateKey?: any[],
    options?: UseMutationOptions<TData, TError, TVariables>
  ) => {
    const queryClient = useQueryClient();
  
    return useMutation({
      mutationFn: fn,
      onSuccess: (data) => {
        invalidateKey?.forEach((key) => {
          queryClient.invalidateQueries(key);
        });
        success?.(data);
      },
      onError: error,
      retry: 1,
      retryDelay: 1000,
      ...options,
    });
  };
